import React from 'react';
import iconMap, { IconName } from '../../assets/icons';

interface SvgIconProps {
  name: IconName;
  className?: string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

const SvgIcon: React.FC<SvgIconProps> = ({
  name,
  className = '',
  width = 20,
  height = 20,
  fill = 'currentColor',
}) => {
  // 🔍 Obtener el ícono o usar el fallback
  const Icon = iconMap[name] || iconMap['default'];

  return React.cloneElement(Icon, {
    className,
    width,
    height,
    fill,
  });
};

export default SvgIcon;
